import { createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/_workspace/ide-next/s/$sessionId")({
  beforeLoad: ({ params }) => {
    if (!/^[A-Za-z0-9_-]{1,200}$/.test(params.sessionId)) {
      throw notFound({ routeId: "/_workspace/ide-next" });
    }
  },
  component: () => null,
});
